module.exports = __webpack_public_path__ + "static/media/chat-img.7ba8f528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat-img.svg
// module id = 297
// module chunks = 25